import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Theme, ThemeIO } from './theme';


@Injectable()
export class ThemesStoreService {
  private _themes = new BehaviorSubject<Theme[]>([]);
  public themes: Observable<Theme[]> = this._themes.asObservable();

  rawData: ThemeIO[] = [];

  setThemes(items: Theme[]): void {
    this._themes.next(items);
  }

}

